<template>
  <div class="page-template">
    <div class="page-title">{{ title }}</div>
    <div class="page-edit">
      <!--      <form-template ref="formTemplate" @submit="submitData">-->
      <!--      </form-template>-->
      <el-form :model="form" :rules="rules" ref="form" class="setting-form" label-width="220px">
        <el-col :span="24">
          <el-form-item prop="integralTerm" label="会员积分有效期">
            <el-select
              class="select-number"
              v-model="form.integralTerm"
              placeholder="请选择"
            >
              <el-option
                v-for="(item,index) in numberList"
                :key="index"
                :label="item.label"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item prop="passwordMemberConsume" label="前台储值卡消费必须输入密码">
            <el-radio-group
              v-model="form.passwordMemberConsume"
              :disabled="isDisabled"
            >
              <el-radio
                v-for="(item,index) in typeList"
                :key="index"
                :label="item.id"
              >{{item.label}}</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>

        <el-col :span="24">
          <el-form-item prop="changeCardStore" label="是否允许修改发卡门店">
            <el-radio-group
              v-model="form.changeCardStore"
              :disabled="isDisabled"
            >
              <el-radio
                v-for="(item,index) in typeList"
                :key="index"
                :label="item.id"
              >{{item.label}}</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item prop="phoneCardCode" label="发卡时会员卡等于手机号">
            <el-radio-group
              v-model="form.phoneCardCode"
              :disabled="isDisabled"
            >
              <el-radio
                v-for="(item,index) in typeList"
                :key="index"
                :label="item.id"
              >{{item.label}}</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item prop="phoneCardCode" label="新会员默认最近">
            <el-input type="number" :min="0" v-model="form.newMemberTime" style="width: 100px"></el-input>天内创建的会员
          </el-form-item>
        </el-col>
      </el-form>
      <div class="foot">
        <el-button type="primary" @click="submitData">提交</el-button>
        <el-button @click="reset">重置</el-button>
      </div>
    </div>
  </div>
</template>
<script>
import api from "../../config/api";
// import api from "@/config/api";

export default {
  components: {
  },
  data() {
    return {
      // numberList:['6','7','8'],
      typeList:[
        {label:'启用',id:1},
        {label:'不启用',id:0},
      ],
      isDisabled:false,
      form:{
        integralTerm:40,// 积分有效期
        passwordMemberConsume:1,// 前台储值卡消费必须输入密码
        changeCardStore:0,//  是否允许修改发卡门店
        phoneCardCode:1,//  发卡时会员卡等于手机号
        newMemberTime:30,//新会员默认最近 ?天内创建的会员
      },
      rules:{},
      title: '',
      dialogVisibility: false,
    };
  },
  computed:{
    numberList(){
      return this.$utils.getCacheStatus("mbMemberDefault.integralTerm")
    },
  },
  created() {
  },
  mounted() {
    this.title = document.title;
    this.getSetDetail()
  },
  methods: {
    // 获取设置详情
    getSetDetail(){
      this.$axios.fetchGet(api.member.mbMemberDefaultDetail, {}).then(data => {
        if (data.code === 200) {
          if(data.data){
            if(data.data.passwordMemberConsume){
              data.data.passwordMemberConsume = 1
            }else{
              data.data.passwordMemberConsume = 0
            }

            if(data.data.changeCardStore){
              data.data.changeCardStore = 1
            }else{
              data.data.changeCardStore = 0
            }

            if(data.data.phoneCardCode){
              data.data.phoneCardCode = 1
            }else{
              data.data.phoneCardCode = 0
            }
            this.form = data.data;
          }
        } else {
          this.$message({message: data.errorMsg, type: 'error'});
        }
      }).catch((err) => {
        this.$message({message: '请求失败', type: 'error'});
      });
    },
    // 重置
    reset(){
      this.form={
        integralTerm:40,// 积分有效期
        passwordMemberConsume:1,// 前台储值卡消费必须输入密码
        changeCardStore:0,//  是否允许修改发卡门店
        phoneCardCode:1,//  发卡时会员卡等于手机号
        newMemberTime:30,//新会员默认最近 ?天内创建的会员
      }
    },
    // 提交
    submitData() {
      const loading = this.$loading({
        lock: true,
        text: '提交中，请稍候...',
        background: 'rgba(225, 225, 225, 0.8)',
      });
      this.$axios.fetchPost(api.member.mbMemberDefault, this.form).then(data => {
        if (data.code === 200) {
          this.getSetDetail()
          this.$notify({
            type: "success",
            title: '提交操作',
            message: '成功',
            showClose: false,
          });
          // this.$message({type: 'success', message: '操作成功'});
        } else {
          this.$message({type: 'error', message: data.errorMsg});
        }
        loading.close()
      }).catch((err) => {
        loading.close()
        this.$message({message: '请求失败', type: 'error'});
      });
    },
  }
};
</script>
<style scoped>
/*.setting-form{*/
/*  height:300px;*/
/*}*/
.foot{
  text-align: center;
}
.select-number{
  width:150px;
}
</style>




// WEBPACK FOOTER //
// src/page/member/Setting.vue